import { render, staticRenderFns } from "./PriceConfigs.vue?vue&type=template&id=4a1c72e7&"
import script from "./PriceConfigs.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports